import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import NotificationList from "../../components/shared/notification/NotificationList";
import { useAuthState } from "../../context/AuthContext";
import EnergoTooltip from "../../components/shared/Tooltip";

const NotificationPage = () => {

    const {tooltips, tooltipsTrigger, user} = useAuthState();

    return (
        <Container className="text-start">
            <div style={{display: "flex"}}>
                <h3 style={{marginRight: 10}}>{user.x_is_management? "Benachrichtigungen": "News"}</h3>
                {tooltipsTrigger?
                    tooltips.find(t => t.code === 6001) !== undefined?
                        <EnergoTooltip text={tooltips.find(t => t.code === 6001).help_text} position="right" /> : null
                :null}
            </div>
            <Row className="mt-5">
                <Col>
                    <NotificationList />
                </Col>
            </Row>
        </Container>
    )
}

export default NotificationPage;